import comFooter from '../../../components/com-footer.vue';
import comHeader from '../../../components/com-header.vue';
export default{
    name:'Login',
    data(){
        return{
            form:{
                userName:'',
                password:'',
                yzm:'',
            },
            options:[],
            checked:'',
            show_num: [], // 验证码值
        }
    },
    components:{
        comFooter,
        comHeader,
    },
    mounted(){
        this.setDrawCode();
        this.isRemember();
    },
    methods:{
        userLogin(){
            var code='';
            if(!this.form.userName){
                this.$message.warning('请输入账户');
                return;
            }
            if(!this.form.password){
                this.$message.warning('请输入密码');
                return;
            }
            for(var i=0;i<this.show_num.length;i++){
                code+=this.show_num[i];
            }
            if(this.form.yzm.toLowerCase()==code){
                var body={
                    userName:this.form.userName,
                    password:this.form.password,
                };
                this.postForm(this.api.login,body).then(res=>{
                    if(res.result==200){
                        this.cookie.set('token',res.data.token);
                        this.cookie.set('userRealName',res.data.userName);
                        this.cookie.set('userID',res.data.id);
                        this.$router.replace('/');
                    }
                }).catch(err=>{
                    this.$message.warning(err.msg);
                });
            }else{
                this.$message.warning('验证码输入错误');
            }
           
        },
        //生成验证图片
        setDrawCode () {
            this.drawCode({
                obj: this.$refs.code,
                width: 95,
                height: 40,
                show_num: this.show_num
            });
        },

        /*
        作用：生产验证码
        参数：obj->dom对象，width->宽度， height->高度，show_num->用来保存验证码的数组
        */
        drawCode ({obj, width, height, show_num}) {
            var canvas_width=width;
                var canvas_height=height;
                var canvas = obj;
                var context = canvas.getContext("2d");//获取到canvas画图的环境，演员表演的舞台
                canvas.width = canvas_width;
                canvas.height = canvas_height;
                var sCode = "a,b,c,d,e,f,g,h,i,j,k,m,n,p,q,r,s,t,u,v,w,x,y,z,A,B,C,E,F,G,H,J,K,L,M,N,P,Q,R,S,T,W,X,Y,Z,1,2,3,4,5,6,7,8,9,0";
                var aCode = sCode.split(",");
                var aLength = aCode.length;//获取到数组的长度
                
                for (var i = 0; i < 4; i++) {  //这里的for循环可以控制验证码位数（如果想显示6位数，4改成6即可）
                    var j = Math.floor(Math.random() * aLength);//获取到随机的索引值
                    // var deg = Math.random() * 30 * Math.PI / 180;//产生0~30之间的随机弧度
                    var deg = Math.random() - 0.5; //产生一个随机弧度
                    var txt = aCode[j];//得到随机的一个内容
                    show_num[i] = txt.toLowerCase();
                    var x = 10 + i * 20;//文字在canvas上的x坐标
                    var y = 20 + Math.random() * 8;//文字在canvas上的y坐标
                    context.font = "bold 23px 微软雅黑";

                    context.translate(x, y);
                    context.rotate(deg);

                    context.fillStyle = this.randomColor();
                    context.fillText(txt, 0, 0);

                    context.rotate(-deg);
                    context.translate(-x, -y);
                }
                for (var i = 0; i <= 5; i++) { //验证码上显示线条
                    context.strokeStyle = this.randomColor();
                    context.beginPath();
                    context.moveTo(Math.random() * canvas_width, Math.random() * canvas_height);
                    context.lineTo(Math.random() * canvas_width, Math.random() * canvas_height);
                    context.stroke();
                }
                for (var i = 0; i <= 30; i++) { //验证码上显示小点
                context.strokeStyle = this.randomColor();
                context.beginPath();
                var x = Math.random() * canvas_width;
                var y = Math.random() * canvas_height;
                context.moveTo(x, y);
                context.lineTo(x + 1, y + 1);
                context.stroke();
            }
        },

        // 随机颜色
        randomColor: function () {
            var r = Math.floor(Math.random() * 256);
            var g = Math.floor(Math.random() * 256);
            var b = Math.floor(Math.random() * 256);
            return "rgb(" + r + "," + g + "," + b + ")";
        },
        rememberPwd(val){
            console.log(val);
			if(val){
				localStorage.setItem('mhRember',val);
				localStorage.setItem('mhusername',this.form.userName);
				localStorage.setItem('mhpassword',this.form.password);
			}else{
				localStorage.removeItem('mhusername');
				localStorage.removeItem('mhpassword');
				localStorage.removeItem('mhRember');
			}		
			
		},
		isRemember(){
			console.log(localStorage.getItem('mhRember'));
			if(localStorage.getItem('mhRember')){
				this.checked=true;
				this.form.userName=localStorage.getItem('mhusername');
				this.form.password=localStorage.getItem('mhpassword');
			}
		}
    }

}